export const parts_table_strings = {
  title: "Parts Inventory",
  description: "Manage your parts inventory",

  // Table columns
  photoColumn: "Photo",
  partTypeColumn: "Type",
  partNumberColumn: "Part Number",
  manufacturerColumn: "Manufacturer",
  turbineModelColumn: "Turbine Model",
  conditionColumn: "Condition",
  categoryColumn: "Category",
  upgradeDesignationsColumn: "Upgrades",
  castingNumberColumn: "Casting Number",
  files: "Files",
  actions: "Actions",
  pedigree: "Pedigree",

  // Action buttons
  createPart: "Create New Part",
  viewPart: "View",
  editPart: "Edit Part",
  deletePart: "Delete Part",
  expressInterest: "Contact For More Info",
  interestExpressed: "Contacted",

  // Standard states
  empty: "No parts found",
  searchPlaceholder: "Search",
  yes: "Yes",
  no: "No",

  // Filter labels
  filters: "Filters",
  advancedFilters: "Advanced Filters",
  toggleFilters: "Toggle advanced filters",
  switchToGridView: "Grid view",
  switchToListView: "List view",
  searchLabel: "Search",
  manufacturerLabel: "Manufacturer",
  manufacturerPlaceholder: "Select manufacturers...",
  conditionLabel: "Condition",
  conditionPlaceholder: "Select conditions...",
  partTypeLabel: "Part Type",
  partTypePlaceholder: "Select part types...",
  clearFilters: "Clear Filters",
  clearAllFilters: "Clear all",
  filterDone: "Done",
  filterSheetCloseAria: "Close",

  // Express Interest Dialog
  expressInterestDialogTitle: "Contact Us For More Info",
} as const;
